import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_r5xk4t473s: FaireBrandEntity = {
  token: "b_r5xk4t473s",
  type: "brand",
  name: "Blue Sage",
  avatarUrl:
    "https://cdn.faire.com/fastly/fb391ec597c8ff2ddbb7cc449bf1d42a7efefa259b0119a1172f75dfe8c44af2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/691073021fcfd4ecdc5097bb0b5fdc60241dfc523524d845f551577ea40a3f58.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fb391ec597c8ff2ddbb7cc449bf1d42a7efefa259b0119a1172f75dfe8c44af2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/691073021fcfd4ecdc5097bb0b5fdc60241dfc523524d845f551577ea40a3f58.jpeg",
  location: "Rochester, NY, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 90,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Blue Sage! Our story started in the basement of our home, woodworking and creating decorative wood pieces finished with non-toxic stains and oils. We loved making shelves for essential oils, and all of our wood oil was infused with essential oils as well, so it felt like a really natural direction to start our own line. 🍃Our oils are sourced direct from distillers all over the world, with a focus on indigenously grown crops without the use of pesticides. We feel strongly that plant medicine should be accessible and of the highest quality. We now have a brick & mortar in Upstate NY, where we sell small made goods in our storefront along with our oils and woodworking pieces, an attached rental studio for yoga and community events, and a refreshment bar serving herb infused dry cocktails, coffee and espresso, tea, and more! We would love for Blue Sage to be a part of your small business or your home. \nOur Etsy shop: https://bluesagelife.etsy.com\nOur Website: https://bluesagelife.com \nFind us on social media: @bluesagelife \nEmail Us: [redacted-email]",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:50.142Z",
    importedBy: "entity-db-cli",
  },
};
